<template>
  <div class="col-md-12 well repeatable-element row m-1 p-2">
    <div class="controls">
      <button type="button" class="close" @click="$emit('on-remove')">
        <span aria-hidden="true">×</span>
      </button>
      <button
        type="button"
        class="close"
        @click="$emit('on-increment')"
        v-if="index !== 0"
      >
        <i class="la la-chevron-up"></i>
      </button>
      <button
        type="button"
        class="close"
        @click="$emit('on-decrement')"
        v-if="index < length - 1"
      >
        <i class="la la-chevron-down"></i>
      </button>
    </div>

    <div class="hidden">
      <input
        type="hidden"
        :name="`${name}[id]`"
        v-model="item.id"
        class="form-control"
        :key="`${name}[id]`"
      />
      <input
        type="hidden"
        :name="`${name}[order]`"
        :value="index"
        class="form-control"
        :key="`${index}-${name}[order]`"
      />
    </div>

    <div class="col-12 mb-4">
      <label>Label</label>
      <FormKit
        type="text"
        :name="`${name}[label]`"
        v-model="item.label"
        class="form-control"
        :key="`${name}[label]`"
      />
    </div>

    <div class="col-12 mb-4">
      <label>Link</label>
      <FormKit
        type="text"
        :name="`${name}[href]`"
        v-model="item.href"
        class="form-control"
        :key="`${name}[href]`"
      />
    </div>

    <div class="col-12 mb-4">
      <FormKit
        label="Type"
        type="select"
        :options="types"
        :name="`${name}[type]`"
        :key="`${name}[type]`"
        v-model="item.type"
        hint="Sommige menu's ondersteunen niet alle types."
      />
    </div>

    <div class="col-12 mb-4" v-if="item.type === 'image'">
      <label>Afbeelding</label>
      <FormKitImage
        label="Afbeelding"
        :name="`${name}[image]`"
        :value="item.image"
        @input="(value) => (item.image = value)"
        :key="`${name}[image]`"
      />
    </div>

    <div class="col-12">
      <div v-for="(subitem, subitemIndex) in item.items" :key="subitem.id">
        <Item
          v-model="item.items[subitemIndex]"
          :index="subitemIndex"
          @on-remove="removeItem(subitemIndex)"
          @on-increment="increment(subitemIndex)"
          @on-decrement="decrement(subitemIndex)"
          without-subitems
          :baseName="name"
          is-nested
          :length="item.items.length"
        />
      </div>
    </div>

    <button
      v-if="!withoutSubitems"
      type="button"
      class="btn btn-outline-primary btn-sm ml-1"
      @click="addItem"
    >
      + Subitem toevoegen
    </button>
  </div>
</template>

<script>
import FormKitImage from "../../components/FormKitImage.vue";
import { v4 as uuidV4 } from "uuid";

export default {
  components: { FormKitImage },
  props: {
    modelValue: {
      type: Object,
    },
    index: {
      type: Number,
    },
    withoutSubitems: {
      type: Boolean,
      default: false,
    },
    baseName: {
      type: String,
      default: "",
    },
    isNested: {
      type: Boolean,
      default: false,
    },
    length: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      item: { ...this.modelValue },
      types: [
        {
          value: "link",
          label: "Link - Voegt een simpele link toe aan het menu.",
        },
        {
          value: "label",
          label: "Label - Voegt een niet aanklikbare label toe",
        },
        {
          value: "image",
          label:
            "Afbeelding - Voegt een afbeelding toe in plaats van tekst in de link",
        },
        {
          value: "button",
          label: "Knop - Laat een knop zien in plaats van een simpele link",
        },
      ],
    };
  },
  methods: {
    addItem() {
      if (!this.item.items) {
        this.item.items = [];
      }

      this.item.items.push({
        id: uuidV4(),
        items: [],
        label: "",
        href: "",
        image: "",
        type: "link",
      });
    },
    removeItem(index) {
      this.item.items.splice(index, 1);
    },
    decrement(index) {
      let item = this.item.items.splice(index, 1)[0];
      this.item.items.splice(index + 1, 0, item);
    },
    increment(index) {
      if (index < 1) {
        return;
      }

      let item = this.item.items.splice(index, 1)[0];
      this.item.items.splice(index - 1, 0, item);
    },
  },
  computed: {
    name() {
      if (this.isNested) {
        return this.baseName + `[items][${this.index}]`;
      }

      return this.baseName + `items[${this.index}]`;
    },
  },
  watch: {
    item: {
      deep: true,
      handler(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>